import { render, staticRenderFns } from "./AcoordeonPreguntas.vue?vue&type=template&id=279234aa"
import script from "./AcoordeonPreguntas.vue?vue&type=script&lang=js"
export * from "./AcoordeonPreguntas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports